var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1822_293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0976 18.8223C21.0975 18.822 21.0975 18.8218 21.0974 18.8215C23.2026 17.0274 24.5 14.5773 24.5 11.8755C24.5 6.37581 19.1274 1.91748 12.5 1.91748C5.87258 1.91748 0.5 6.37581 0.5 11.8755C0.5 17.3751 5.87258 21.8335 12.5 21.8335C14.716 21.8335 16.7913 21.3344 18.5727 20.4653C18.5728 20.4653 20.5673 22.8418 24.5 21.8335C24.5 21.8335 21.3255 20.4498 21.0976 18.8223Z",
    fill: "#FF6F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43163 11.8755C2.43163 6.64562 7.29012 2.35782 13.4658 1.94964C13.1472 1.92859 12.8252 1.91748 12.5 1.91748C5.87258 1.91748 0.5 6.37576 0.5 11.8755C0.5 17.3751 5.87258 21.8335 12.5 21.8335C12.8253 21.8335 13.1474 21.8224 13.4661 21.8013C7.29027 21.3932 2.43163 17.1054 2.43163 11.8755Z",
    fill: "#FC5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7103 11.1141C12.9946 11.6737 12.9816 12.0641 12.9816 12.7408C12.9816 12.9881 12.8514 13.2744 12.2138 13.2744C11.6802 13.2744 11.498 13.0792 11.498 12.4025C11.498 11.2834 11.9925 10.7498 12.3699 10.4245C12.7993 10.0601 13.5281 9.65665 13.5281 8.95395C13.5281 8.35536 13.0076 8.06904 12.3569 8.06904C11.0295 8.06904 11.3158 9.07104 10.6131 9.07104C10.2617 9.07104 9.83228 8.83681 9.83228 8.32925C9.83228 7.62654 10.6391 6.58545 12.3959 6.58545C14.0616 6.58545 15.1677 7.50936 15.1677 8.73265C15.1677 9.95595 14.0617 10.8409 13.7103 11.1141ZM13.2288 15.1743C13.2288 15.7078 12.7863 16.1763 12.2268 16.1763C11.6672 16.1763 11.2378 15.7078 11.2378 15.1743C11.2378 14.6277 11.6802 14.1723 12.2268 14.1723C12.7734 14.1723 13.2288 14.6277 13.2288 15.1743Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1822_293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.1957347ffb98b221408e9529f5893872.svg";
export { ForwardRef as ReactComponent };